// Submit Content layout - renders child routes (deliverable list or submission form)

import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId",
)({
  component: SubmitContentLayout,
});

function SubmitContentLayout() {
  return <Outlet />;
}
